// planIconMap.js
// Deterministic plan -> icon config lookup, inferred from the plan's
// name/planType text. Same plan always resolves to the same icon - pure
// keyword match, never randomized.
//
// Icons are the SAME local assets used by BENEFIT_CARD_CONFIG
// (see benefitCardConfig.js) - no more hand-drawn SVG components.
// A plan card and a benefit card for the same service now always show
// the identical badge, and there's nothing here that can resolve to
// `undefined` and crash the renderer.

import { BENEFIT_CARD_CONFIG, DEFAULT_BENEFIT_CONFIG } from "./benefitIconMap";

// Each rule maps a keyword pattern to a key in BENEFIT_CARD_CONFIG.
const RULES = [
  { test: /dental|tooth/i, key: "Dental" },
  { test: /diagnos|lab|pathology|screen/i, key: "Diagnostic" },
  { test: /scan|imag|radiolog|x-?ray|mri|ct\b/i, key: "Scans" },
  { test: /vision|eye|optical/i, key: "Vision Care" },
  { test: /physio|rehab|therapy\b/i, key: "Condition Management" },
  { test: /pharma|medicin|drug/i, key: "Pharmacy" },
  { test: /mental|psych|counsel/i, key: "Mental Wellness" },
  { test: /wellness|heart|fitness/i, key: "Fitness" },
  { test: /checkup|health.?check/i, key: "AHC" },
  { test: /consult|doctor|opd|teleconsult/i, key: "Doctor Consultation" },
];

/** Returns { icon, tint } for a plan - never throws, always returns something. */
export function getPlanIcon(plan) {
  const haystack = `${plan?.name || plan?.planName || ""} ${plan?.planType || ""}`;
  const rule = RULES.find((r) => r.test.test(haystack));
  const config = rule ? BENEFIT_CARD_CONFIG[rule.key] : DEFAULT_BENEFIT_CONFIG;
  return { icon: config.icon, tint: config.tint };
}